import template from './calendar.html';
import controller from './calendar.controller';
import 'angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isOnline: '<',
    staffUser: '<'
  }
};

export default component;
